<h2 mat-dialog-title>Prenota una call con un nostro esperto</h2>
<p class="ms-4 text-small">Il caricamento del calendario potrebbe richiedere qualche secondo</p>

    <mat-dialog-content class="pt-3" style="min-height: 400px; position: relative;">

      <div *ngIf="isLoading" class="w-100 h-100 d-flex justify-content-center align-items-center position-absolute top-0 start-0">
        <mat-spinner diameter="50"></mat-spinner>
        <p class="ms-3 mb-0 text-muted">Caricamento calendario...</p> </div>

      <iframe 
        [hidden]="isLoading"
        (load)="onIframeLoad()"
        src="https://updates.actiwise.biz/widget/booking/kjZpCi2Ei9hlPtDAhsuk"
        style="width: 100%; border: none; overflow: hidden; min-height: 600px;" 
        scrolling="no" 
        id="kjZpCi2Ei9hlPtDAhsuk_1774878488942">
      </iframe>

      <div [hidden]="isLoading" id="form_embed_script_container"></div>

    </mat-dialog-content>

    <mat-dialog-actions align="end">
      <button mat-button mat-dialog-close>
        <mat-icon>arrow_back</mat-icon>
        Torna alle chat
      </button>
    </mat-dialog-actions>
